// extracted by mini-css-extract-plugin
export default {"Dialog":"CreateTagDialog-module__Dialog--a69Xp"};